<template>
    <table class="table table-sm table-striped">
        <thead class="thead-dark">
        <tr>
            <th></th>
            <th>Unique Logins</th>
            <th>Total Logins</th>
        </tr>
        </thead>
        <tr>
            <td>Scheme To Date</td>
            <td>{{ context.logins.all.unique }}</td>
            <td>{{ context.logins.all.total }}</td>
        </tr>
        <tr>
            <td>{{ monthName }} {{ year }}</td>
            <td>{{ context.logins.month.unique }}</td>
            <td>{{ context.logins.month.total }}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "ReportLogins",
        props: ['context','year','monthName']
    }
</script>

<style scoped>

</style>
